import React, {Component} from 'react';
import {Button, Card, CardHeader, CardBody, CardFooter} from "reactstrap";
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";
import {isUndefined} from "lodash";

class NextSurveys extends Component {


  getCashPoints(collector) {
    if (collector.survey.endCashPointsMax) {
      return collector.survey.endCashPointsMax;
    }

    return !isUndefined(collector.endCashPoints) ? collector.endCashPoints : collector.survey.endCashPoints;
  }

  render() {
    const query = new URLSearchParams(location.search);
    const isMobileApp = !!query.get('mobileApp');

    return <div className="mt-4">
      <p className="mb-3"><FormattedMessage id="nextSurveys.header.seeAlso"/>:</p>
      {this.props.nextSurveys.map(collector => {
        return <div className="d-inline-block col-12 col-md-4 p-2"><Card key={collector.guid}>
          <CardHeader tag="h3">{collector.survey.nameOryginal}</CardHeader>
          <CardBody>
            CashPoints: {this.getCashPoints(collector)}<br />
            SocialPoints: {collector.survey.endSocialPoints}<br />
          </CardBody>
          <CardFooter>
            {isMobileApp === false && <Button color="primary" className="w-100" onClick={() => window.location.assign('/s/' + collector.guid)}><FormattedMessage id="nextSurveys.button.fill"/></Button>}
            {isMobileApp === true && <Button color="primary" className="w-100" onClick={() => window.location.assign('swpanel-app://s/' + collector.guid)}><FormattedMessage id="nextSurveys.button.fill"/></Button>}
          </CardFooter>
        </Card></div>
      })}
    </div>
  }
}

NextSurveys.propTypes = {
  nextSurveys: PropTypes.arrayOf(PropTypes.shape({
    guid: PropTypes.string.isRequired,
    survey: PropTypes.shape({
      name: PropTypes.string.isRequired,
      endSocialPoints: PropTypes.number.isRequired,
      endCashPoints: PropTypes.number.isRequired,
    }).isRequired,
  })).isRequired,
};

export default NextSurveys;